;(function ( $ ) {

    /**
     *  submitOnChange
     *  submit parent form when control fires change event
     **/

    'use strict';

    // Create the defaults once
    var pluginName = 'notesForm';
    var defaults = {};

    // The actual plugin constructor
    function Plugin ( element, options ) {
        this.element = element;
        this.settings = $.extend( {}, defaults, options );
        this._defaults = defaults;
        this._name = pluginName;
        this.init();
    }

    // Avoid Plugin.prototype conflicts
    $.extend(Plugin.prototype, {
        init: function () {
            this.registerEvents();
        },
        registerEvents: function() {
            var _this = this;

            $(this.element).find('.show-notes-form').on('click', function(e) {
                e.preventDefault();
                $(this).fadeOut(400);
                if (!$(_this.element).find('.notes-headline').filter(':visible').length) {
                    $(_this.element).find('.notes-headline').removeClass('is-hidden').fadeIn(400);
                }
                $(_this.element).find('.notes-form textarea').val('');
                $(_this.element).find('.notes-form').slideDown(400);
            });
            $(this.element).find('.edit-notes-form').on('click', function(e) {
                console.log('Edit', $('.note-entry-body').text());
                e.preventDefault();
                $(this).fadeOut(400);
                if (!$(_this.element).find('.notes-headline').filter(':visible').length) {
                    $(_this.element).find('.notes-headline').removeClass('is-hidden').fadeIn(400);
                }
                $(_this.element).find('.notes-form textarea').val($('.note-entry-body').text().replace(/ +(?= )/g,''));
                $(_this.element).find('.notes-form').slideDown(400);
            });
            $(this.element).find('.hide-notes-form').on('click', function(e) {
                e.preventDefault();
                $(_this.element).find('.notes-form').slideUp(400);
                $(_this.element).find('.show-notes-form').fadeIn(400);
                if (!$(_this.element).find('.note-entry').length) {
                    $(_this.element).find('.notes-headline').addClass('is-hidden');
                }
            });
        }
    });

    $.fn[ pluginName ] = function ( options ) {
        return this.each(function() {
            if ( !$.data( this, 'plugin_' + pluginName ) ) {
                $.data( this, 'plugin_' + pluginName, new Plugin( this, options ) );
            }
        });
    };
})( jQuery );
